import { render, staticRenderFns } from "./BaseFilterBar.vue?vue&type=template&id=53aa63e6"
import script from "./BaseFilterBar.vue?vue&type=script&lang=js"
export * from "./BaseFilterBar.vue?vue&type=script&lang=js"
import style0 from "./BaseFilterBar.vue?vue&type=style&index=0&id=53aa63e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports